var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_frame",
    "data-name": "vuesax/outline/frame",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.79,7.345H3.733a.384.384,0,0,0-.128,0,3.644,3.644,0,1,1,.205,0ZM3.676,1.063a2.611,2.611,0,0,0-.1,5.22,1.169,1.169,0,0,1,.227,0,2.612,2.612,0,0,0-.128-5.22Z",
    transform: "translate(4.823 0.885)",
    fill: "#96a0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H17V17H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.362,7.163A7,7,0,0,1,1.523,6.1,3.04,3.04,0,0,1,0,3.586,3.071,3.071,0,0,1,1.523,1.057a7.5,7.5,0,0,1,7.678,0,3.056,3.056,0,0,1,1.523,2.515A3.071,3.071,0,0,1,9.2,6.1,7.014,7.014,0,0,1,5.362,7.163ZM2.111,1.95A2.037,2.037,0,0,0,1.062,3.593,2.032,2.032,0,0,0,2.111,5.222a6.4,6.4,0,0,0,6.5,0A2.037,2.037,0,0,0,9.662,3.579,2.032,2.032,0,0,0,8.613,1.95,6.434,6.434,0,0,0,2.111,1.95Z",
    transform: "translate(3.258 8.81)",
    fill: "#96a0b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user_profile.56d13a5ee0568e9787d273ec15ac2831.svg";
export { ForwardRef as ReactComponent };